export const noFollowDomains = [
  "segment.com",
  "getcensus.com",
  "mparticle.com",
  "flywheelsoftware.com",
  "workato.com",
  "rudderstack.com",
  "lytics.com",
  "tealium.com",
  "simondata.com",
  "actioniq.com",
  "amperity.com",
  "matillion.com",
  "informatica.com",
  "braze.com",
  "offerfit.ai",
  "movableink.com",
  "aampe.com",
];
